var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLowBattery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6087 34.9314H17.3973C16.6602 34.8982 16.0337 35.4568 15.9922 36.1853V40.0525C16.0357 40.781 16.6622 41.3376 17.3973 41.3025H30.6087C31.3418 41.3377 31.9683 40.779 32.0079 40.0525V36.1853C31.9703 35.4587 31.3438 34.8982 30.6087 34.9314Z",
    fill: "#E31C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0534 6.8789H28.2708V5.1406C28.2708 4.5117 27.755 4.00195 27.1186 4H20.7925C20.1561 4.00195 19.6423 4.51365 19.6423 5.1406V6.87695L16.9506 6.8789C15.3221 6.8789 14 8.1836 14 9.7949V41.0879C14.004 42.6973 15.3241 44 16.9506 44H31.0534C32.6798 43.998 33.998 42.6953 34 41.0879V9.7949C34 8.1855 32.6818 6.88085 31.0534 6.8789ZM33.0138 41.0899V41.0879C33.0119 42.1582 32.1344 43.0235 31.0534 43.0254H16.9506C15.8676 43.0254 14.9881 42.1582 14.9862 41.0879V9.79495C14.9881 8.7227 15.8676 7.8555 16.9506 7.85355H31.0534C32.1364 7.85745 33.0119 8.72465 33.0138 9.79495V41.0899Z",
    fill: "#E31C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowBattery);
export default __webpack_public_path__ + "static/media/lowBattery.926283fceb4209a6b0b556a4ab403f64.svg";
export { ForwardRef as ReactComponent };